/**
 * Niveles de monitoreo
 */
export enum MonitoringLevel {
  FATAL = 'fatal',
  ERROR = 'error',
  WARNING = 'warning',
  INFO = 'info',
  DEBUG = 'debug'
}

/**
 * Dominios y eventos de monitoreo
 */
export interface IMonitoringEvent {
  [key: string]: { 
    [key: string]: IContentMonitoringEvent 
  };
}

/**
 * Detalle de eventos de monitoreo
 */
export interface IContentMonitoringEvent {
  type: MonitoringLevel;
  description: string;
}

/**
 * Mensajes de monitoreo
 */
export const MONITORING_MESSAGES: IMonitoringEvent = {
  AUTH: {
    CHANGE_PASSWORD: {
      type: MonitoringLevel.INFO,
      description: 'Cierre de sesión por cambio de contraseña'
    }
  }
};


